<div class="dropdown-nested" ngbDropdown #drp="ngbDropdown" placement="bottom-start"
	(openChange)="accordion.collapseAll()">
	<button data-testid="SUBSYS2_RINGSEL_BTN" type="button" class="dropdown-nested-toggle"
		[class]="{ 'item-selected': ngModel }" ngbDropdownToggle [disabled]="disabled">
		@if (!ngModel) {
		<span data-testid="SUBSYS2_RINGSEL_PLACEHOLDER">{{placeholder}}</span>
		} @else {
		<img [src]="imageUrl(ngModel.ringType)" alt="ring type" />
		<span data-testid="SUBSYS2_RINGSEL_VALUE">
			{{(ngModel.ringType | ringTypeLabel:isFoot) + " - " + ngModel.description}}
		</span>
		}
	</button>
	<div ngbDropdownMenu aria-labelledby="dropdownForm1">
		<div ngbAccordion #accordion="ngbAccordion" [closeOthers]="true">
			@for (type of ringTypeList; track type) {
			<div ngbAccordionItem [id]="type">
				<div ngbAccordionHeader>
					<button [attr.data-testid]="'SUBSYS2_RINGSEL_' + type" type="button" ngbAccordionToggle>
						<img [src]="imageUrl(type)" alt="ring type" />
						<span>{{type | ringTypeLabel:isFoot}}</span>
					</button>
				</div>
				<div ngbAccordionCollapse>
					<div ngbAccordionBody>
						@for (ring of ringList?.[type] ; track ring.id) {
						@if (ring) {
						<button [attr.data-testid]="'SUBSYS2_RINGSEL_' + type + '_' + ring.description" type="button"
							(click)="select(ring);drp.close();">
							{{ ring?.description }}
						</button>
						}
						}
					</div>
				</div>
			</div>
			}
		</div>
	</div>
</div>